import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/transactions/`;

export const transactions = {
  get: () => generateApiPath(pathBase),
};
